import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import sgrLockIcon from '../../assets/SGRLock_icon.png';
import { IValidationResponse, useSteps } from '../../contexts/stepContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import api from '../../services/api';
import { Title } from '../../styles/global';
import { Content, GoBack } from '../BodyStep/styles';
import FlowButton from '../FlowButton';
import Loading from '../Loading';
import InstructionItem from '../InstructionItem';
import {
  BulbIcon,
  ContainerInstructions,
  GlassIcon,
  UserPhotoIcon,
  RotatePhoneIcon,
  RegSquare,
  Focus,
} from './styles';

const Instructions: React.FC = () => {
  const [skipping, setSkipping] = useState(false);

  const {
    currentValidation,
    handleChangeCurrentStep,
    handleReturnCurrentStep,
    handleJumpSteps,
    handleSetImage,
    documentNum,
    birthday,
    name,
    documentType,
    zipCode,
    phoneNumber,
    email,
    selectedServices,
    setResult,
    setMessageError,
    setServiceError,
    skipPhotoRequested,
    setSkipPhotoRequested,
    setServiceResults,
  } = useSteps();

  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.components.instructions);

  const handleSkipPhoto = async () => {
    setSkipping(true);
    try {
      const blob = await fetch(sgrLockIcon).then(r => r.blob());
      const base64 = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      handleSetImage(base64);

      const { data } = (await api
        .post('validationrequest', {
          document: documentNum,
          selfie: base64,
          birth_date: birthday,
          name,
          document_type: documentType,
          zip_code: zipCode || undefined,
          phone_number: phoneNumber || undefined,
          email: email || undefined,
          imageJwt: '',
          api_key: process.env.REACT_APP_API_KEY_UNICO,
          selected_services: selectedServices.map(s => s.cos_ser_id),
        })
        .then(response => response)) as { data: IValidationResponse };

      if (data.result) setResult(data.result);
      if (data.message) setMessageError(data.message);
      if (data.service) setServiceError(data.service);
      setServiceResults(data.results ?? []);

      handleJumpSteps(2);
    } catch {
      setSkipping(false);
    }
  };

  useEffect(() => {
    if (skipPhotoRequested) {
      setSkipPhotoRequested(false);
      handleSkipPhoto();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skipPhotoRequested]);

  if (skipPhotoRequested || skipping) {
    return <Loading />;
  }

  return (
    <Content>
      <GoBack onClick={handleReturnCurrentStep}>
        <FaArrowLeft size={16} />
        {tp('back')}
      </GoBack>
      <Title>{tp('title')}</Title>
      {currentValidation === 'Foto' ? (
        <ContainerInstructions>
          <InstructionItem text={tp('selfie.faceVisible')}>
            <UserPhotoIcon />
          </InstructionItem>
          <InstructionItem text={tp('selfie.goodLighting')}>
            <BulbIcon />
          </InstructionItem>
          <InstructionItem text={tp('selfie.removeAccessories')}>
            <GlassIcon />
          </InstructionItem>
          <InstructionItem text={tp('selfie.avoidRotation')}>
            <RotatePhoneIcon />
          </InstructionItem>
        </ContainerInstructions>
      ) : (
        <ContainerInstructions>
          <InstructionItem text={tp('document.flatSurface')}>
            <RegSquare />
          </InstructionItem>
          <InstructionItem text={tp('document.goodLighting')}>
            <BulbIcon />
          </InstructionItem>
          <InstructionItem text={tp('document.adjustFocus')}>
            <Focus />
          </InstructionItem>
          <InstructionItem text={tp('document.avoidRotation')}>
            <RotatePhoneIcon />
          </InstructionItem>
        </ContainerInstructions>
      )}

      <FlowButton text={tp('next')} onClick={handleChangeCurrentStep} />
    </Content>
  );
};

export default Instructions;
